module.exports = __webpack_public_path__ + "static/media/Cowboy Bandit800_1c.e43ef7e0.svg";